import * as Type from '../actions/firewallLogs/types'

import { executeCallback, setInMemory } from '@services/store/utils'

const initialState = {
    data: {},
    formated: {
        selected: null,
        list: [],
        pagination: {
            page: 0,
            itemsCount: 0,
            controlled: true,
            nextToken: null
        }
    },
    filters: {},
    loaded: null
}

export default function FirewallLogsReducer(state = initialState, action) {
    if (action.type === Type.POPULATE) {
        return executeCallback(
            setInMemory(state, action, 'data'),
            action,
            'firewallLogs'
        )
    }
    else if (action.type === Type.SET_FORMAT) {
        return executeCallback(
            setInMemory(state, action, 'formated'),
            action,
            'firewallLogs'
        )
    }
    else if (action.type === Type.SET_FORMAT_LIST) {
        return executeCallback(
            setInMemory(state, action, 'formated', 'list'),
            action,
            'firewallLogs'
        )
    }
    else if (action.type === Type.SET_FORMAT_PAGINATION) {
        return executeCallback(
            setInMemory(state, action, 'formated', 'pagination'),
            action,
            'firewallLogs'
        )
    }
    else if (action.type === Type.SET_FILTERS) {
        return executeCallback(
            setInMemory(state, action, 'filters'),
            action,
            'firewallLogs'
        )
    }
    else if (action.type === Type.SET_LOADED) {
        return executeCallback(
            setInMemory(state, action, 'loaded'),
            action,
            'firewallLogs'
        )
    }

    return state
}
